// extracted by mini-css-extract-plugin
module.exports = {"dialog":"banner_dialog__psysj","buttons":"banner_buttons__52Rif"};